import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./components/App.tsx";
import { RootStore, StoreContext } from "./stores/RootStore.ts";

const stores = new RootStore();

stores.connection.connect();

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <StoreContext.Provider value={stores}>
            <App />
        </StoreContext.Provider>
    </StrictMode>,
);

// Makes the app installable and lets it open without a connection.
// Service workers only work on pages from a web server, not in the desktop app.
if ("serviceWorker" in navigator && location.protocol.startsWith("http")) navigator.serviceWorker.register("sw.js");
